import { Component, OnInit, Input } from '@angular/core';
import { ICarePlan, IAppointment } from '@ahryman40k/ts-fhir-types/lib/R4';
import { AbstractAddComponent } from '../../../shared/abstracts/add/abstract-add/abstract-add.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'inc-appointment-frequency',
  templateUrl: './appointment-frequency.component.html',
  styleUrls: ['./appointment-frequency.component.scss'],
})
export class AppointmentFrequencyComponent extends AbstractAddComponent<ICarePlan> implements OnInit {
  @Input() periods: any[];
  @Input() nextAppointments: IAppointment[];
  minDate: Date;

  constructor() {
    super();
  }

  ngOnInit() {
    this.minDate = new Date();
    if (this.inData && this.inData.activity && this.inData.activity.length) {
      this.inData.activity[0].detail.scheduledPeriod.start =
        this.inData.activity[0].detail.scheduledPeriod.start && (this.inData.activity[0].detail.scheduledPeriod.start as any).seconds ?
          new Date((this.inData.activity[0].detail.scheduledPeriod.start as any).seconds * 1000).toISOString() :
          (this.inData.activity[0].detail.scheduledPeriod.start !== '' ? this.inData.activity[0].detail.scheduledPeriod.start : '');
      this.form.patchValue(this.inData.activity[0].detail);
    }
    this.form.valueChanges.subscribe(form => {
      const period = form.scheduledTiming.repeat.period;
      const periodUnit = form.scheduledTiming.repeat.periodUnit;
      const startDate = form.scheduledPeriod.start;
      if (startDate !== '') {
        const endDate = this.addToDate(new Date(startDate), Number(period), periodUnit).toISOString();
        this.form.get('scheduledString').setValue(endDate, { onlySelf: true, emitEvent: false });
      }
    });
  }

  addToDate(startDate: Date, period: number, periodUnit: string): Date {
    let newDate = new Date(startDate);
    switch (periodUnit) {
      case 'a': return new Date(newDate.setFullYear(newDate.getFullYear() + period));
      case 'mo': return new Date(newDate.setMonth(newDate.getMonth() + period));
      case 'wk': return new Date(newDate.setDate(newDate.getDate() + period * 7));
      case 'd': return new Date(newDate.setDate(newDate.getDate() + period));
      default: return startDate;
    }
  }

  ngOnChanges() {
    if (this.nextAppointments && this.nextAppointments[0]) {
      const endDate = new Date(this.nextAppointments[0].requestedPeriod[0].start).toISOString();
      this.form.get('scheduledString').setValue(endDate, { onlySelf: true, emitEvent: false });
    }
  }

  save(data: any) {
    this.inData.activity && this.inData.activity.length ? this.inData.activity[0].detail = data : this.inData.activity = [{ detail: data }];
    this.inData ? this.callUpdate.emit(this.inData) : this.callSave.emit(this.inData);
    this.form.reset(this.form.value);
  }

  resetForm() {
    return new FormGroup({
      scheduledTiming: new FormGroup({
        repeat: new FormGroup({
          period: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
          periodUnit: new FormControl('', Validators.required),
        })
      }),
      scheduledPeriod: new FormGroup({
        start: new FormControl('', Validators.required),
      }),
      scheduledString: new FormControl({ value: '', disabled: true })
    });
  }
}
